import React from 'react';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';

/**
 * Google Analytics component
 * This component handles initialization and page view tracking
 * for Google Analytics across all routes
 */
const GoogleAnalytics: React.FC = () => {
  useGoogleAnalytics();
  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
